import "@fontsource/oswald/700.css";
import type { CSSProperties } from "react";

import { cn } from "../lib/utils";

/**
 * HeyDex's name, drawn as HeyDay News's lockup is: the red rail, HEY in white on the
 * desk black and DEX in white on the red at the same height. It carries its own black
 * and red, so it reads on either theme. `height` is the lockup's height in pixels.
 */
export function HeyDexWordmark({
  height = 22,
  className,
}: {
  height?: number;
  className?: string;
}) {
  return (
    <span
      className={cn("heydex-lockup", className)}
      style={{ "--lockup-h": `${height}px` } as CSSProperties}
      aria-hidden
    >
      <span />
      <span>HEY</span>
      <span>DEX</span>
    </span>
  );
}
